import React from "react";
import CustomerForm from "./CustomerForm";

function App() {
  return (
    <>
      <CustomerForm />
    </>
  );
}

export default App;
